import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelCategoryConfiguration from './ModelCategoryConfiguration';
import { getUserProfileWidget } from '../../selectors/index';
import {
    describeModelCategoryThunk,
    modelCategoryCleanUpThunk
} from '../../actions/modelCategory';

const mapStateToProps = state => {
    return {
        userProfileWidgets: getUserProfileWidget(state),
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            describeModelCategory: (modelCategoryId, organisationId, widgetCode) => describeModelCategoryThunk(modelCategoryId, organisationId, widgetCode),
            modelCategoryCleanUp: modelCategory => modelCategoryCleanUpThunk(modelCategory)
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ModelCategoryConfiguration);
